import { useMemo } from "react";
import { DEVICE_TYPE } from "../utils/constants";
import { useAppSelector } from "../redux-store/CustomReduxHooks";
import { isEmpty } from "lodash";

const useDeviceDetection = () => {
  const navtiveAppDetails = useAppSelector(
    (state) => state.CsAppSlice.NativeDeviceInfo,
  );

  const deviceType: DEVICE_TYPE = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|windows phone/g.test(userAgent);
    const isPWA = window.matchMedia("(display-mode: standalone)").matches;

    if (isPWA) {
      return isMobile ? DEVICE_TYPE.PWA_MOBILE : DEVICE_TYPE.PWA_WEB;
    } else if (isMobile) {
      return isEmpty(navtiveAppDetails)
        ? DEVICE_TYPE.ABC_WEB_MOB_CS
        : DEVICE_TYPE.MOBILE;
    }
    return DEVICE_TYPE.WEB;
  }, [navtiveAppDetails]);

  return deviceType;
};

export default useDeviceDetection;
